
    /** @jsxImportSource react */
    import useIcon, { IconProps } from '../hooks/useIcon';

    export default (props : IconProps) => {
      const svgProps = useIcon(props);
      return (
        <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" {...svgProps}>
  <circle cx="12" cy="12" r="10"/>
  <path d="M12 16v-4"/>
  <path d="M12 8h.01"/>
</svg>
      );
    };